import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=60862e02"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=60862e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports